export default __webpack_public_path__ + "static/media/withdrawal-empty.dacf4f0a.png";